/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData } from "./persisterService";
import { persistLitigationSubEntities } from "./AbstractLitigationCasePersister";
import { UseForm } from "../../types/UseForm";
import { CivilServiceLaw } from "../../types/Products/AdministrativeLaw/CivilServiceLaw/CivilServiceLaw";

export const persistCivilServiceLaw = async (updateData: UseForm["values"], origCivilServiceLawCase: CivilServiceLaw) => {
  await persistLitigationSubEntities(updateData, origCivilServiceLawCase);

  const apiUri = getProductData(origCivilServiceLawCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origCivilServiceLawCase);

  await apiPatch(apiUri, origCivilServiceLawCase.id, contractCaseUpdateData);
};
